import { cn } from "@/lib/utils";
import type * as React from "react";

interface MutedProps extends React.HTMLAttributes<HTMLParagraphElement> {
  as?: "p" | "span";
  className?: string;
}

function Muted({ className, children, as = "p", ...props }: MutedProps) {
  const Component = as || "p";
  return (
    <Component
      className={cn("text-muted-foreground text-sm", className)}
      data-slot="muted"
      {...props}
    >
      {children}
    </Component>
  );
}

export { Muted };
